<template>
  <div class="wizard-step-indicator">
    <template v-for="(step, index) in numberedSteps">
      <div
        :key="`step-${index}`"
        :class="{
          'wizard-step': true,
          active: index === currentStep,
        }"
        class="mx-2"
        @click="changeStep(index)"
      >
        <div class="step-content">
          <feather-icon :icon="stepIcons[index]" size="16" />
          <div class="step-label text-capitalize">{{ step }}</div>
        </div>
      </div>

      <!-- Arrow after each step, except the last one -->
      <div v-if="index < numberedSteps.length - 1" class="arrow" :key="'arrow-' + index">
        <feather-icon icon="ChevronRightIcon" size="22" />
      </div>
    </template>
    <div v-if="currentStep == 1" class="reload-icon">
      <feather-icon icon="RotateCwIcon" size="20" @click="changeStep(0)" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentStep: Number,
    numberedSteps: Array,
  },
  data() {
    return {
      stepIcons: ["UserCheckIcon", "SearchIcon"],
    };
  },
  methods: {
    changeStep(index) {
      this.$emit("step-clicked", index);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables/_variables.scss";

.wizard-step-indicator {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.wizard-step {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #6e6b7b;
  opacity: 0.7;
  transition: color 0.15s ease-in-out, opacity 0.15s ease-in-out;

  &:hover {
    opacity: 1;
  }

  .dark-layout & {
    color: $theme-dark-headings-color;
  }
}

.wizard-step.active {
  color: var(--primary);
  opacity: 1;
  font-weight: 600;

  .dark-layout & {
    color: $theme-dark-label-color;
  }
}

.step-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.step-label {
  margin-top: 4px;
  font-size: 0.9rem;
}

.arrow {
  display: flex;
  align-items: center;
  color: #b9b9c3;

  .dark-layout & {
    color: $theme-dark-text-muted-color;
  }
}

.reload-icon {
  position: absolute;
  right: 0.25rem;
  top: 50%;
  transform: translateY(-50%);

  svg {
    cursor: pointer;
  }
}
</style>
